<form [formGroup]="userCredentials" (ngSubmit)="login()" class="sh-panel">
  <h1>{{ "login.title" | translate }}</h1>
  <fieldset class="sh-form-fieldset">
    <sh-form-text-input
      [id]="'username'"
      autocomplete="username"
      [control]="userCredentials.controls.username"
      [label]="'login.user' | translate"
      [errorMsg]="'form.error.required-field' | translate"
    ></sh-form-text-input>
    <sh-form-password
      [id]="'password'"
      autocomplete="current-password"
      [control]="userCredentials.controls.password"
      [label]="'login.password' | translate"
      [errorMsg]="'form.error.required-field' | translate"
      >
    </sh-form-password>
    @if ((error$ | async)) {
      <sh-notification
        [type]="notificationTypes.Error"
        [message]="'login.error.invalid-credentials' | translate"
        [icon]="'delete'"
      ></sh-notification>
    }
    <div class="sh-action-group">
      <button class="sh-button sh-action-group__item" [disabled]="(loading$ | async)" type="submit">
        @if (!(loading$ | async)) {
          {{ 'login.actions.login' | translate}}
        }
        @if (loading$ | async) {
          {{ 'login.state.loggingIn' | translate }}
        }
      </button>
    </div>
    @if ((showOauth$|async)) {
      <hr />
      <h6 class="sh-cl">{{ "login.or-login-using" | translate}}</h6>
      <a [href]="oauthUrl$ | async" class="sh-button--secondary" [ngClass]="(loading$ | async) ? '-sh-disabled':''"
        >{{ "login.actions.oauthLogin" | translate}}</a
        >
      }
    </fieldset>
  </form>
